import React from 'react';
import { createExtendedSvgIcon } from '../IconBase';

export default createExtendedSvgIcon({
  path: (
    <g>
      <path d="M89.3 80.9c.3.3.4.8.3 1.2s-.5.8-.9.9c-.4.1-.9 0-1.2-.4L79.8 75v23.1c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2V75l-7.6 7.6c-.5.5-1.3.5-1.8 0-.2-.2-.4-.5-.4-.9s.1-.6.4-.9l8.9-8.9c.5-.5 1.1-.7 1.8-.7s1.3.3 1.7.7l8.9 9zm-69.4 1.2c0 2.8 2.3 5.1 5.1 5.1h32.2l-1.1 1.4-31.1.1c-3.7 0-6.6-2.9-6.6-6.6V69.5h-2.2c-3.2 0-5.9-2.6-5.9-5.8V42.9c0-3.2 2.6-5.8 5.9-5.8h2.2V13.9c0-3.6 3-6.6 6.6-6.6h33.8c1.8 0 3.4.7 4.7 2l20 19.9c1.3 1.2 2 2.9 2 4.7V53L68.8 69.5H19.9v12.6zm0-68.2v23.2h64v-3.3c0-1-.3-1.9-.8-2.7H61.5V9.6c-.8-.5-1.8-.8-2.8-.8H25c-2.8 0-5.1 2.2-5.1 5.1z" />
    </g>
  ),
  displayName: 'FileType',
  viewBox: '0 0 100 100',
  textContainer: {
    x: '22',
    y: '62',
    fontSize: '24',
  },
});
